import React, { useState, useEffect, useRef } from 'react';
import { senvraApi } from '../utils/axiosInstance';
import logo from "../pages/certificateAssests/logo.png";
import msme from "../pages/certificateAssests/msme.png";
import dpit from "../pages/certificateAssests/dpiit.png";
import sign from "../pages/certificateAssests/sign.png";
import badge from "../pages/certificateAssests/badge.png";


// Helper: convert local image to base64
const getBase64Image = async (imagePath) => {
  try {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error converting image to base64:', error);
    return imagePath;
  }
};

// Exact certificate template – only <div> + <style> (no outer HTML tags)
const generateCertificateHtml = (data) => {
  return `
<style>
    .certificate {
        width: 1122px;
        height: 793px;
        position: relative; overflow: hidden;
        border: 18px solid #0b2a4a;
        box-sizing: border-box;
        background: radial-gradient(circle, #ffffff 0%, #fcf9f2 100%);
        margin: auto;
        flex-shrink: 0;
        font-family: "Times New Roman", serif;
        color: #333;
    }
    .gold-frame {
        position: absolute; top: 8px; left: 8px; right: 8px; bottom: 8px;
        border: 2px solid #d4af37;
        pointer-events: none;
    }
    .logo-left { position: absolute; top: 50px; left: 55px; }
    .logo-left img { width: 210px; }
    .badge-frame {
        position: absolute;
        top: 9px;
        right: 70px;
    }
    .badge-frame img {
        width: 140px;
        filter: drop-shadow(0px 5px 10px rgba(0,0,0,0.15));
    }
    .meta-info {
        margin: 20px auto 0 auto;
        width: 100%;
        text-align: center;
        font-size: 15px;
        color: #777;
        letter-spacing: 1px;
    }
    .main-content { text-align: center; margin-top: 100px; padding: 0 100px; }
    h1 {
        font-size: 55px;
        color: #0b2a4a; margin: 0;
        letter-spacing: 10px;
        font-weight: bold;
        text-transform: uppercase;
    }
    h2 {
        font-size: 22px; letter-spacing: 6px; color: #d4af37;
        margin: 10px 0 45px 0; font-weight: normal;
    }
    .presented-text { font-size: 22px; margin-bottom: 15px; font-style: italic; color: #555; }
    .name {
        font-size: 49px; font-weight: bold; color: #0b2a4a;
        display: inline-block; padding: 0 40px;
    }
    .name-line {
        width: 50%; border-top: 1px solid #cfcfcf;
        margin: 12px auto 25px auto;
    }
    .desc {
        font-size: 19px; line-height: 1.6; width: 80%; margin: 0 auto; color: #444;
    }
    .footer-table {
        position: absolute; bottom: 55px; width: 100%;
        border-collapse: collapse; table-layout: fixed;
    }
    .footer-col { text-align: center; vertical-align: bottom; padding: 0 20px; }
    .footer-sign { height: 80px; margin-bottom: 12px; }
    .footer-center-logo { height: 95px; margin-bottom: 10px; }
    .footer-msme { width: 180px; height: auto; margin-bottom: 10px; }
    .sig-line {
        width: 220px; margin: 0 auto;
        border-top: 2px solid #0b2a4a;
        padding-top: 10px; font-size: 15px; font-weight: bold; color: #0b2a4a;
    }
    .address-bar {
        position: absolute; bottom: 0; width: 100%;
        text-align: center; font-size: 13px; color: #fff;
        background-color: #0b2a4a; padding: 10px 0; letter-spacing: 1px;
    }
</style>
<div class="certificate">
    <div class="gold-frame"></div>
    <div class="logo-left">
        <img src="${data.logo}" alt="Logo" />
    </div>
    <div class="meta-info">
        Certificate ID: <strong>${data.certificate_id}</strong> &nbsp; | &nbsp; Date: <strong>${data.issued_date}</strong>
    </div>
    <div class="badge-frame">
        <img src="${data.badge}" alt="Medal" />
    </div>
    <div class="main-content">
        <h1>CERTIFICATE</h1>
        <h2>OF PROFESSIONAL ACHIEVEMENT</h2>
        <div class="presented-text">This Certificate is Proudly Presented To</div>
        <div class="name">${data.name}</div>
        <div class="name-line"></div>
        <div class="desc">
            Has successfully completed the
            <span style="font-weight: bold; font-size: 22px; color: #0b2a4a;">${data.course_name}</span>
            training program on <span style="font-weight: bold; font-size: 22px; color: #0b2a4a;">${data.start_date}</span>
            and fulfilled all academic and practical requirements.
            The candidate has demonstrated technical proficiency, analytical skills,
            and professional competence in accordance with organizational standards.
        </div>
    </div>
    <table class="footer-table">
        <tr>
            <td class="footer-col">
                <img src="${data.sign}" class="footer-sign" />
                <div class="sig-line">Managing Director</div>
            </td>
            <td class="footer-col">
                <img src="${data.dpit}" class="footer-center-logo" />
            </td>
            <td class="footer-col">
                <img src="${data.msme}" class="footer-msme" />
                <div class="sig-line">Ministry of MSME</div>
            </td>
        </tr>
    </table>
    <div class="address-bar">
        SENVRA AI &#8226; Hyderabad &#8226; www.senvraai.com
    </div>
</div>
  `;
};

// Generate full standalone HTML page for PDF rendering
const generateFullHtmlPage = (data) => {
  const certHtml = generateCertificateHtml(data);
  return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body {
    width: 1122px;
    height: 793px;
    overflow: hidden;
    background: white;
  }
</style>
</head>
<body>
${certHtml}
</body>
</html>`;
};

const Verify = () => {
  // Custom styles for animations
  const animationStyles = `
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes slideInFromBottom {
      from { transform: translateY(2rem); }
      to { transform: translateY(0); }
    }
    .animate-in {
      animation-duration: 0.7s;
      animation-fill-mode: forwards;
      animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }
    .fade-in { animation-name: fadeIn; }
    .slide-in-from-bottom-8 { animation-name: slideInFromBottom; }
  `;

  const [certId, setCertId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  // OTP flow states
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpError, setOtpError] = useState('');

  // Base64 images for PDF
  const [base64Images, setBase64Images] = useState({
    logo: null,
    badge: null,
    sign: null,
    dpit: null,
    msme: null,
  });

  // Load images
  useEffect(() => {
    const loadImages = async () => {
      try {
        const [logoB64, badgeB64, signB64, dpitB64, msmeB64] = await Promise.all([
          getBase64Image(logo),
          getBase64Image(badge),
          getBase64Image(sign),
          getBase64Image(dpit),
          getBase64Image(msme),
        ]);
        setBase64Images({ logo: logoB64, badge: badgeB64, sign: signB64, dpit: dpitB64, msme: msmeB64 });
      } catch (error) {
        console.error('Error loading images:', error);
      }
    };
    loadImages();
  }, []);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!certId.trim()) return;

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const token = localStorage.getItem('access_token');
      const response = await senvraApi.get(`/certificate/verify`, {
        params: { cert_id: certId.trim() },
        headers: { Authorization: token ? `Bearer ${token}` : undefined }
      });
      if (response.data.valid) {
        setResult(response.data.data);
      } else {
        setError(response.data.message || response.data.error || 'Invalid Certificate ID');
      }
    } catch (err) {
      console.error('Verification error:', err);
      const backendError = err.response?.data?.message || err.response?.data?.error;
      setError(backendError || 'Failed to verify certificate. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Function to request OTP for certificate download
  const handleDownloadClick = async () => {
    if (!result || !result.certificate_id) {
      alert('Certificate data missing');
      return;
    }

    setOtpSending(true);
    setOtpError('');
    try {
      // API call to request OTP
      await senvraApi.post('/certificate/otp/request', {
        cert_id: result.certificate_id
      });
      // Show OTP input modal
      setShowOtpModal(true);
      setOtp('');
    } catch (err) {
      console.error('OTP request error:', err);
      setOtpError(err.response?.data?.message || 'Failed to send OTP. Please try again.');
    } finally {
      setOtpSending(false);
    }
  };

  // Function to verify OTP and download certificate
  const handleOtpVerify = async () => {
    if (!otp.trim()) {
      setOtpError('Please enter OTP');
      return;
    }
    setOtpVerifying(true);
    setOtpError('');
    try {
      const response = await senvraApi.post('/certificate/otp/verify', {
        cert_id: result.certificate_id,
        otp: otp.trim()
      });
      // Response example: { cert_id, type, course_name, user_name, quiz_date, html_url }
      const certData = response.data;
      // Close OTP modal
      setShowOtpModal(false);

      // Now trigger PDF download using our template
      if (base64Images.logo) {
        await downloadCertificatePdf(certData);
      } else {
        alert('Images are still loading. Please try again in a moment.');
      }
    } catch (err) {
      console.error('OTP verification error:', err);
      setOtpError(err.response?.data?.message || 'Invalid OTP. Please try again.');
    } finally {
      setOtpVerifying(false);
    }
  };

  // PDF download function (same logic as Dashboards)
  const downloadCertificatePdf = async (certData) => {
    try {
      const fullHtml = generateFullHtmlPage({
        name: certData.user_name || 'User',
        course_name: certData.course_name || 'Skill Course',
        certificate_id: certData.cert_id || result.certificate_id,
        issued_date: certData.quiz_date || new Date().toLocaleDateString(),
        start_date: certData.quiz_date || new Date().toLocaleDateString(),
        logo: base64Images.logo,
        badge: base64Images.badge,
        sign: base64Images.sign,
        dpit: base64Images.dpit,
        msme: base64Images.msme,
      });

      // Create hidden iframe
      const iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1122px;height:793px;border:none;visibility:hidden;';
      document.body.appendChild(iframe);

      iframe.contentDocument.open();
      iframe.contentDocument.write(fullHtml);
      iframe.contentDocument.close();

      // Wait for iframe to render
      await new Promise((resolve) => {
        iframe.onload = resolve;
        setTimeout(resolve, 2000);
      });

      if (iframe.contentDocument.fonts) {
        await iframe.contentDocument.fonts.ready;
      }

      // Wait for images
      await new Promise((resolve) => {
        const imgs = iframe.contentDocument.getElementsByTagName('img');
        if (imgs.length === 0) return resolve();
        let loaded = 0;
        const check = () => { loaded++; if (loaded >= imgs.length) resolve(); };
        Array.from(imgs).forEach(img => {
          if (img.complete && img.naturalWidth > 0) check();
          else { img.onload = check; img.onerror = check; }
        });
        setTimeout(resolve, 3000);
      });

      await new Promise(r => setTimeout(r, 500));

      const html2canvas = (await import('html2canvas')).default;
      const { jsPDF } = await import('jspdf');

      const certElement = iframe.contentDocument.querySelector('.certificate');
      const canvas = await html2canvas(certElement, {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        width: 1122,
        height: 793,
        windowWidth: 1122,
        windowHeight: 793,
        logging: false,
      });

      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [1122, 793],
        hotfixes: ['px_scaling'],
      });

      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      pdf.addImage(imgData, 'JPEG', 0, 0, 1122, 793, undefined, 'FAST');
      pdf.save(`Senvra_Certificate_${certData.cert_id || 'Download'}.pdf`);

      document.body.removeChild(iframe);
    } catch (error) {
      console.error('PDF download error:', error);
      alert('Failed to download PDF. Please try again.');
    }
  };

  return (
    <main className="pt-[140px] pb-20 bg-[#f8fafc] dark:bg-slate-950 min-h-screen flex items-start justify-center">
      <style dangerouslySetInnerHTML={{ __html: animationStyles }} />
      <div className="max-w-[1200px] w-full px-5 flex flex-col items-center">
        {/* Verification Card */}
        <div className="w-full max-w-[650px] bg-white dark:bg-slate-900 rounded-[32px] shadow-[0_40px_100px_rgba(0,0,0,0.04)] border border-slate-100 dark:border-slate-800 relative overflow-hidden transition-all duration-500">
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-sky-400 via-emerald-400 to-rose-400"></div>

          <div className="p-8 md:p-14">
            <div className="text-center">
              <div className="relative inline-block mb-8">
                <div className="w-20 h-20 bg-blue-600 dark:bg-blue-500 rounded-3xl flex items-center justify-center mx-auto shadow-2xl shadow-blue-500/40 relative z-10 overflow-hidden group">
                  <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    <polyline points="9 11 12 14 15 10"></polyline>
                  </svg>
                </div>
                <div className="absolute inset-0 bg-blue-500 blur-2xl opacity-20 animate-pulse"></div>
              </div>

              <h1 className="text-4xl md:text-5xl font-black text-slate-900 dark:text-white mb-6 tracking-tight">
                Authenticity Check
              </h1>
              <p className="text-slate-500 dark:text-slate-400 text-lg mb-12 max-w-lg mx-auto leading-relaxed font-medium">
                Verify the legitimacy of <span className="text-blue-600 font-bold">SENVRA AI</span> credentials.
              </p>

              <form onSubmit={handleVerify} className="text-left">
                <div className="mb-8">
                  <label className="block text-[11px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[2px] mb-4 ml-1">
                    Certificate ID
                  </label>
                  <div className="relative group">
                    <div className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors">
                      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                      </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="e.g. CERT-QUIZ-1234567890"
                      value={certId}
                      onChange={(e) => setCertId(e.target.value)}
                      className="w-full bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-2xl py-5 pl-14 pr-6 outline-none focus:border-blue-500/50 focus:ring-4 focus:ring-blue-500/5 transition-all font-bold text-slate-700 dark:text-white text-lg placeholder:text-slate-300 dark:placeholder:text-slate-700"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading || !certId.trim()}
                  className={`w-full py-6 rounded-2xl font-black text-xl transition-all shadow-xl active:scale-[0.98] flex items-center justify-center gap-3 relative overflow-hidden group ${
                    loading || !certId.trim()
                      ? 'bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-600 cursor-not-allowed shadow-none'
                      : 'bg-[#0f172a] dark:bg-white text-white dark:text-slate-900 hover:shadow-2xl hover:shadow-blue-500/10'
                  }`}
                >
                  {loading ? (
                    <>
                      <div className="w-6 h-6 border-3 border-current border-t-transparent rounded-full animate-spin"></div>
                      <span>Securing Verification...</span>
                    </>
                  ) : (
                    <span className="relative z-10">Validate Credentials</span>
                  )}
                </button>
              </form>

              {error && (
                <div className="mt-8 p-5 bg-rose-50 dark:bg-rose-900/10 border border-rose-100 dark:border-rose-900/30 rounded-2xl animate-in fade-in">
                  <div className="flex items-center gap-3 text-rose-600 dark:text-rose-400">
                    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                      <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                    </svg>
                    <span className="font-bold text-sm uppercase tracking-wide">{error}</span>
                  </div>
                </div>
              )}
            </div>

            {/* Verification Result Display */}
            {result && (
              <div className="mt-12 animate-in fade-in slide-in-from-bottom-8 duration-700 ease-out fill-mode-forwards">
                <div className="p-1 bg-gradient-to-br from-emerald-400/20 via-blue-400/20 to-purple-400/20 rounded-[32px]">
                  <div className="p-8 md:p-10 bg-white dark:bg-slate-900 rounded-[31px] relative overflow-hidden shadow-2xl shadow-blue-500/5">
                    {/* Verified Seal */}
                    <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-500/5 dark:bg-emerald-400/5 rounded-full flex items-center justify-center border border-emerald-500/10 rotate-12 pointer-events-none">
                      <div className="w-24 h-24 border-2 border-dashed border-emerald-500/20 rounded-full flex items-center justify-center">
                        <span className="text-[10px] font-black text-emerald-500/40 tracking-widest uppercase">Verified</span>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-10 relative z-10">
                      <div>
                        <div className="flex items-center gap-2 bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 px-4 py-2 rounded-full text-[11px] font-black uppercase tracking-[1px] border border-emerald-100 dark:border-emerald-800/50 mb-2">
                          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                          Authentic & Verified
                        </div>
                      </div>
                      <div className="text-right">
                        <span className="text-[10px] font-black text-slate-300 dark:text-slate-600 uppercase tracking-[2px] block mb-1">Certificate ID</span>
                        <code className="text-blue-600 dark:text-blue-400 font-mono font-black text-sm bg-blue-50 dark:bg-blue-900/20 px-3 py-1 rounded-lg">{result.certificate_id}</code>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8 mb-10 relative z-10">
                      <div>
                        <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Candidate Name</h3>
                        <p className="text-2xl font-black text-slate-900 dark:text-white">{result.student_name}</p>
                      </div>
                      <div>
                        <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Qualified Course</h3>
                        <p className="text-2xl font-black text-slate-900 dark:text-white">{result.course_name}</p>
                      </div>
                      <div>
                        <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Certification Type</h3>
                        <p className="text-slate-700 dark:text-slate-200 font-bold text-lg">{result.type}</p>
                      </div>
                      <div>
                        <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Issued Date</h3>
                        <p className="text-slate-700 dark:text-slate-200 font-bold text-lg">{result.issued_on}</p>
                      </div>
                    </div>

                    {/* Bottom Action Area */}
                    <div className="bg-slate-50 dark:bg-slate-950/50 p-6 md:p-8 rounded-[28px] border border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-8 relative z-10">
                      <div className="flex items-center gap-5">
                        <div className="relative">
                          <svg className="w-20 h-20 transform -rotate-90">
                            <circle cx="40" cy="40" r="36" stroke="currentColor" strokeWidth="8" fill="transparent" className="text-slate-200 dark:text-slate-800" />
                            <circle cx="40" cy="40" r="36" stroke="currentColor" strokeWidth="8" fill="transparent" strokeDasharray={`${(result.score / 100) * 226} 226`} strokeLinecap="round" className="text-blue-500" />
                          </svg>
                          <div className="absolute inset-0 flex items-center justify-center flex-col">
                            <span className="text-lg font-black text-slate-900 dark:text-white leading-none">{result.score}</span>
                            <span className="text-[8px] font-black text-slate-400 uppercase tracking-tighter">Score</span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col w-full sm:w-auto gap-3">
                        <button 
                          onClick={handleDownloadClick}
                          disabled={otpSending}
                          className="group bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-2xl font-black text-sm transition-all shadow-xl shadow-blue-500/20 active:scale-95 flex items-center justify-center gap-3 disabled:opacity-50"
                        >
                          {otpSending ? (
                            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          ) : (
                            <svg className="w-5 h-5 group-hover:-translate-y-1 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                              <polyline points="7 10 12 15 17 10"></polyline>
                              <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                          )}
                          Download Certificate
                        </button>
                        <button onClick={() => { setResult(null); setCertId(''); }} className="px-8 py-3 rounded-2xl font-black text-[11px] uppercase tracking-widest text-slate-400 hover:text-slate-600 transition-colors">
                          Verify Another ID
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      {showOtpModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
          <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-md p-8 animate-in fade-in">
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2">Enter OTP</h2>
            <p className="text-sm text-slate-500 mb-6">An OTP has been sent to your registered email/phone.</p>
            {otpError && <p className="text-red-500 text-sm mb-4">{otpError}</p>}
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full p-3 border border-slate-300 rounded-xl mb-4 dark:bg-slate-800 dark:border-slate-700 dark:text-white outline-none focus:border-blue-500"
              maxLength={6}
            />
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => { setShowOtpModal(false); setOtp(''); setOtpError(''); }}
                className="px-4 py-2 bg-slate-200 dark:bg-slate-700 rounded-xl font-bold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleOtpVerify}
                disabled={otpVerifying}
                className="px-4 py-2 bg-blue-600 text-white rounded-xl font-bold text-sm flex items-center gap-2 disabled:opacity-50"
              >
                {otpVerifying ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : null}
                Verify & Download
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default Verify;